import { FC, useEffect } from 'react'
import { TabPanel } from 'react-tabs'
import CN from 'classnames'

import { ShippingLineSelection } from 'components/molecules/ShippingLineSelection'

export interface TabAusPostInternationalProps {
  className?: string | undefined
  shipment: any
  searchForSavedQuotes: any
  selectedOrderId?: any
  notify?: any
  callOrderShipmentsById?: any
  setMainLoadingState?: any
  isAPXDisable?: boolean
}

export const TabAusPostInternational: FC<TabAusPostInternationalProps> = ({
  className,
  shipment,
  searchForSavedQuotes,
  selectedOrderId,
  notify,
  callOrderShipmentsById,
  setMainLoadingState,
  isAPXDisable,
}: TabAusPostInternationalProps) => {
  return (
    <div className='w-full pt-6 border-t border-t-N-200'>
      {shipment.shipmentConsignmentQuotes &&
        shipment.shipmentConsignmentQuotes.length > 0 &&
        shipment.shipmentConsignmentQuotes.map((quote: any, index: any) => {
          const obj = {
            type: quote.type,
            productName: quote.productName,
            shipmentId: shipment.id,
            productId: quote.productId,
            cost: quote.cost,
            originCharges: [
              {
                type: 'Calculated Price',
                price: quote.calculatedPrice,
              },
              {
                type: 'Calculated Price Ex Gst',
                price: quote.calculatedPriceExGst,
              },
              {
                type: 'Calculated Price Gst',
                price: quote.calculatedPriceExGst,
              },
            ],
          }
          if (quote.type === 'AUSPOST_INTERNATIONAL') {
            return (
              <ShippingLineSelection
                key={index}
                isViewOnly={
                  shipment?.status === 'CLOSED' ||
                  shipment?.status === 'CANCELLED'
                }
                ShippingLineObject={obj}
                selectedOrderId={selectedOrderId}
                dateWanted={shipment?.dateWanted}
                notify={notify}
                callOrderShipmentsById={callOrderShipmentsById}
                setMainLoadingState={setMainLoadingState}
                isAPXDisable={isAPXDisable}
              />
            )
          }
        })}
      {shipment.shipmentConsignmentQuotes &&
        searchForSavedQuotes(
          shipment.shipmentConsignmentQuotes,
          'AUSPOST_INTERNATIONAL',
        )}
    </div>
  )
}

TabAusPostInternational.defaultProps = {
  className: undefined,
}

export default TabAusPostInternational
